define((require) => {
    "use strict";

    const ChunkingCollection = require("data/ChunkingCollection");
    const SyncManager        = require("shared/services/sync/SyncManager");
    const RestApi            = require("shared/services/RestApi");
    const Channel            = require("ui/publish/channelSetup/Channel");

    /**
     * Represents a (chunking) collection of channels, supporting "lazy loading".
     *
     * @see  ChunkingCollection
     * @class ChannelCollection
     */
    const ChannelCollection = ChunkingCollection.extend("ChannelCollection", {

        model: Channel,

        url(options = {}) {
            if (options.project) {
                // projects/{PROJECT_ID}/channels
                return RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, options.project.get("id"), RestApi.Collections.CHANNELS);
            }

            return RestApi.pathToCollection(RestApi.Collections.CHANNELS);
        }

    }, {

        /**
         * Counts the total amount of (the logged in principal's) channels.
         *
         * @param  {Object}         options Options set of options.
         * @param  {ProjectModel}   options.project A <tt>ProjectModel</tt> - for counting all project specific channels.
         * @return {Promise}        A <tt>Promise</tt> that resolves with the total number of (the logged in principal's) channels.
         */
        count(options = {}) {
            let url = RestApi.Collections.CHANNELS_COUNT;
            const project = options && options.project;

            if (project) {
                // projects/{ID}/channels/count
                url = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.CHANNELS_COUNT);
            }

            return SyncManager.get(url, SyncManager.target("ChannelCollection.count"));
        }

    });

    return ChannelCollection;
});



// WEBPACK FOOTER //
// ./src/editor/data/ChannelCollection.js